import styles from './Introduce.module.scss'
import { Button } from '../components/Button'

export const Introduce: React.FC = () => {
  return (
    <div className={styles.introduce_container}>
      <div className={styles.main_container}>
        <p className={styles.title}>
          Amazon ECSを今すぐ導入して
          <br />
          運用の悩みを解決しましょう
        </p>
        {/* <Button text="サービス資料をダウンロード" href="資料追加" /> */}
      </div>
    </div>
  )
}
